import { createContext } from 'react'

import { MeetingsMeetingRoomFragment } from 'generated/resources/graphql'

export type TranscriptionSessionType = {
  id?: string
  attendeeId?: string
  companyId?: string
  disconnectedAt?: string
  createdAt?: string
}

export interface RoomContextState {
  room: MeetingsMeetingRoomFragment | null
  isSideBarOpen: boolean
  setIsSideBarOpen: (state: boolean) => void
  isChatOpen: boolean
  setIsChatOpen: (state: boolean) => void
  loading: boolean
  error: string | null
  refetchRoom: () => Promise<void>
  // Meeting sounds settings
  soundsEnabled: boolean
  setSoundsEnabled: (enabled: boolean) => void
  // Pending messages
  pendingMessagesCount: number
  addPendingMessage: () => void
  clearPendingMessages: () => void
  // Transcript control
  isTranscriptEnabled: boolean
  setIsTranscriptEnabled: (enabled: boolean) => void
}

export const RoomContext = createContext<RoomContextState | undefined>(undefined)
